import * as React from 'react';
import { useFragment } from 'react-relay';
import { abstractBlockFragment } from './AbstractBlock.relay';
import ReactMarkdown from 'react-markdown';
import type { AbstractBlockPropsType } from './types';

const AbstractBlock: React.FC<AbstractBlockPropsType> = ( props: AbstractBlockPropsType ) => {
    const contentBlock = useFragment( abstractBlockFragment, props.contentBlock );

    return (
        <div className="text-xs font-sans leading-[21px] text-black [&_*]:text-xs [&_*]:font-sans [&_*]:leading-[21px] [&_*]:text-black [&_p]:mb-4">
            <ReactMarkdown>{ contentBlock.text }</ReactMarkdown>
        </div>
    );
};

export { AbstractBlock };
